export class StandardOutputModel {
    public result!: string
    public successCode!: number 
    public successMessage!: string 

}